import { createEntityAdapter } from '@reduxjs/toolkit';

import type RootState from 'app-components/utils/redux-store/rootState';

import {
  type DetailedQuote,
  INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY,
  type QuotesSecurityType,
} from './investmentsQuotesDetailedTypes';
import { keyFromQuote, keyFromSymbolAndType } from './investmentsQuotesDetailedUtils';

const adapter = createEntityAdapter<DetailedQuote, string>({
  selectId: keyFromQuote,
});

type State = Pick<RootState, typeof INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY>;

const adapterSelectors = adapter.getSelectors((state: State) => state[INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY]);

export const getStore = (state: State) => state[INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY];

export const getDetailedQuotes = adapterSelectors.selectAll;
export const getDetailedQuotesById = adapterSelectors.selectEntities;
export const getDetailedQuotesLoading = (state: State) => getStore(state).isLoading;
export const getDetailedQuotesError = (state: State) => getStore(state).error;

export const getDetailedQuoteBySymbolAndType = (
  state: State,
  symbol: string,
  securityType: QuotesSecurityType = 'STOCK',
) => {
  const key = keyFromSymbolAndType(symbol, securityType);
  return adapterSelectors.selectById(state, key);
};
